import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=d20ba4ec&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"
import style0 from "./menu.vue?vue&type=style&index=0&id=d20ba4ec&prod&lang=less"
import style1 from "./menu.vue?vue&type=style&index=1&id=d20ba4ec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20ba4ec",
  null
  
)

export default component.exports